<template>
	<div class="mt palm-mt- u-palm-visuallyhidden ph c-default-transparent-container">
		<h4 class="u-text-weight--light u-text-color--brand">Waarom {{supplierName}}?</h4>
		<ul class="o-list--check u-text-color-grey">
			<li v-for="(usp, $index) in uspList" :key="$index">{{usp}}</li>
		</ul>
	</div>
</template>

<script>
export default {
	props: {
		supplierName: {
			type: String,
			default: ''
		},
		uspList: {
			type: Array,
			default: () => []
		}
	}
};
</script>
